
import Dashboard from "@/src/screens/dashboard/dashboard";

export default function DashboardScreen() {
  return <Dashboard />;
}
